import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202604",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 8461,
  clicks: 116,
  adsSpendDollars: 424,
  budgetDollars: 14500,
  salesDollars: 4478,
  bestEstimateRoas: 10.56,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.03,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
